import { STOCK_AUDIT_TAB } from "../framework/tab/tabUtilsConstants";
import { newProduct } from "../utils/constant";
export const STOCK_AUDIT_COLUMN_DEFS = "stock_audit_column_defs";
export const initial_state_stock_audit = {
  label: "Stock Audit",
  type: STOCK_AUDIT_TAB,
  productRowData: [newProduct],
  actors: {
    startDate: null,
    branches: null,
    remarks: null,
  },
  stockAuditSummary: {
    totalItem: 0,
    totalQty: 0,
    totalLoose: 0,
  },
  lastProductSelectedIndex: 0,
};

export const stock_audit_col_defs = [
  {
    headerName: "Sr.",
    field: "custom_sr_no",
    canHide: false,
    resizable: false,
    editable: false,
    locked: true,
    cellClass: "custom-ag-cell-uneditable",
    valueGetter: "node.rowIndex ? node.rowIndex : ''",
    minWidth: 50,
    maxWidth: 50,
    lockPosition: true,
  },
  {
    headerName: "Product",
    field: "medicineNameDetailed",
    resizable: true,
    editable: false,
    minWidth: 600,
    locked: true,
    hide: false,
    lockPosition: true,
  },
  {
    headerName: "Remarks",
    field: "remarks",
    editable: true,
    resizable: true,
    width: 650,
    locked: false,
    hide: false,
    valueGetter: params => (params.data.remarks ? params.data.remarks : ''),
  },
];
